export function gcd(a, b) {
  return b === 0 ? a : gcd(b, a % b);
}

export function simplify(num, den) {
  const g = gcd(Math.abs(num), Math.abs(den));
  return { num: num / g, den: den / g };
}

export function randInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function fractionStr(num, den) {
  return `${num}/${den}`;
}

export function pick(arr) {
  return arr[randInt(0, arr.length - 1)];
}
